import moment from 'moment';
import React from 'react';

import { Language } from '../enum';
import 'moment/locale/es';
import 'moment/locale/pt';
import { i18n } from '../utils';

export interface TranslatorComponentProps {
  children?: React.ReactNode;
  defaultLang?: Language;
}

export const getAppLang = () => document.querySelector('html')?.getAttribute('lang') || undefined;

export const TranslatorComponent: React.FC<TranslatorComponentProps> = ({
  children,
  defaultLang,
}) => {
  const htmlLang = getAppLang();
  const simplifiedLang = defaultLang ?? htmlLang?.substring(0, 2) ?? Language.en;

  i18n.changeLanguage(simplifiedLang);
  moment.locale(simplifiedLang);

  return <>{children}</>;
};
